<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useColors } from 'vuestic-ui'

const { applyPreset } = useColors()

// Theme initialization
onMounted(() => {
  const THEME_STORAGE_KEY = 'trafix_admin_theme'

  // Function to get saved theme or detect system preference
  const getSavedTheme = (): string => {
    // First check localStorage
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY)
    if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
      return savedTheme
    }

    // If no saved theme, detect system preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark'
    }

    // Default to light
    return 'light'
  }

  const savedTheme = getSavedTheme()
  applyPreset(savedTheme)
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
